//@author: devin
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ComponentFactoryResolver,
    ElementRef,
    NgZone,
    Renderer2,
    ViewEncapsulation,
} from "@angular/core";
import { S25ItemComponent } from "../s25.item.component";
import { TypeManagerDecorator } from "../../../main/type.map.service";

@TypeManagerDecorator("s25-item-organization")
@Component({
    selector: "s25-item-organization",
    template: `
        @if (init) {
            <s25-item
                [modelBean]="modelBean"
                [includeTypeIcon]="includeTypeIcon"
                [popoverTemplate]="organizationTooltip"
                [blockDetailsNav]="blockDetailsNav"
                [contextMenuOnBody]="contextMenuOnBody"
            ></s25-item>
        }

        <ng-template #organizationTooltip>
            <div class="qtip-content org-info">
                @if (!modelBean.initPopOver) {
                    <div>Loading...</div>
                }
                @if (modelBean.initPopOver && !modelBean.data?.item) {
                    <div class="organizationBox popoverroot">Could not load organization details</div>
                }
                @if (modelBean.initPopOver && modelBean.data?.item) {
                    <div class="organizationBox popoverroot">
                        <div
                            class="boxHeader"
                            (contextmenu)="contextMenu({ itemTypeId: 2, itemId: modelBean.itemId }, $event)"
                        >
                            <div class="boxHeaderName">{{ modelBean.data.item.item_name }}</div>
                        </div>
                        <div class="boxBody">
                            @for (row of modelBean.data.item.rows; track trackByFn($index, row)) {
                                <div>
                                    <span class="c-dataLabel"> {{ row.name }}</span>
                                    <span> {{ row.value }}</span>
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        </ng-template>
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25ItemOrganizationComponent extends S25ItemComponent {
    constructor(elementRef: ElementRef, zone: NgZone, cd: ChangeDetectorRef) {
        super(elementRef, zone, cd);
    }

    ngOnInit() {
        this.itemTypeId = 2;
        super.ngOnInit();
    }
}
